import React from 'react';
import classNames from 'classnames';
import { LocaleString, getString } from '@nackle/intl-tools';
import { Space, Divider, Button, Flex, Typography } from '@nackle/origami';
const { Text } = Typography;
import { CloseLarge } from '@nackle/origami-icons';

import { ADMIN_SESSION_START_KEY, ASSUMPTION_TYPES } from '../constants.js';
const {
    PROXY,
    DELEGATE,
    OPERATOR
} = ASSUMPTION_TYPES;
import { useSessionStorage } from '../hooks';
import Timer from '../timer/timer.jsx';

import './admin-banner.less';

const getType = ( assumptionType ) => {
    let type = null;
    switch ( assumptionType ) {
        case PROXY:
            type = 'loggedInAs';
            break;
        case DELEGATE:
            type = 'actingAs';
            break;
        case OPERATOR:
            console.log( `admin banner does not support assumption type ${ assumptionType }` );
            break;
        default:
            console.log( `unknown assumption type - ${ assumptionType }` );
            break;
    }
    return type;
};

const AdminBanner = ( { user, identityAssumption, onLogOut, restoreIdentity } ) => {

    const [ sessionStartTime ] = useSessionStorage( ADMIN_SESSION_START_KEY, new Date() );

    const type = getType( identityAssumption );

    const handleLogout = () => {
        if ( typeof onLogOut === 'function' ) {
            onLogOut();
        }
    };

    const bannerClasses = classNames(
        'nkl-deck-admin-banner',
        `nkl-deck-admin-banner-${ type }`
    );

    const subject = user?.claims || {};

    return (
        <>
            {
                type ?
                    <Flex
                        className={ bannerClasses }
                        justify="space-between"
                        align="center"
                        flex="auto"
                    >
                        <Space
                            className="admin-user-info"
                            split={ <Divider type="vertical" /> }
                        >
                            <Text ellipsis>
                                <LocaleString
                                    code={ `deck.adminBanner.info.${ type }` }
                                    replaceOptions={ {
                                        subjectGivenName: subject.given_name,
                                        subjectSurname: subject.family_name
                                    } }
                                />
                            </Text>

                            {
                                identityAssumption === PROXY ?
                                    <Timer startTime={ new Date( sessionStartTime ) } />
                                    : null
                            }

                        </Space>
                        {
                            identityAssumption === PROXY ?
                                <Button
                                    id={ 'admin-logout-btn' }
                                    type="link"
                                    size="small"
                                    aria-label={ getString( 'deck.link.logout' ) }
                                    onClick={ handleLogout }
                                >
                                    <LocaleString code={ 'deck.link.logout' } replaceOptions={ { subjectGivenName: subject.given_name } } />
                                </Button>
                                :
                                <Button
                                    id={ 'delegate-end-session-btn' }
                                    type="link"
                                    size="small"
                                    aria-label={ getString( 'deck.adminBanner.button.endSession' ) }
                                    onClick={ restoreIdentity }
                                >
                                    <CloseLarge width="16" height="16" />
                                    <LocaleString code={ 'deck.adminBanner.button.endSession' } />
                                </Button>
                        }
                    </Flex >
                    :
                    null
            }
        </>
    );
};

export default AdminBanner;